import * as React from 'react';
import { PersonInfoForm } from '../../Add/components/PersonInfoForm';
import { momentAgeNow, momentToString } from '../../../../share/utils/utils';
import { Row, Col, Label } from 'reactstrap';

const AdvancedLayout = (props: { that: PersonInfoForm; index: number, person: any }) => (
    <Row className="person margin-forms">
        <Header {...props} />
        <Date {...props} />
        <Sex {...props} />
        <Weight {...props} />
        <Height {...props} />
        <EyeColor {...props} />
        <HairColor {...props} />
    </Row>
)


export const PersonLayout = (props) => {
    const that: PersonInfoForm = props.that;
    const person = props.person;
    const personId = that.props.type === 'child' ? person.childId : person.abductorId;
    person.age = person.birthDate ? momentAgeNow(person.birthDate) : "";
    return <AdvancedLayout key={personId} {...props} />
}

const Header = ({ that, index }: { that: PersonInfoForm, index: number }) => {
    const name = that.props.personsInfo[index].fullName;
    return (
        <Col className={"col-12 header-person transfer-label"}>
            <h6 className="child-name">
                {name ? name : "\xa0"}
            </h6>
        </Col>
    )
}


const Date = ({ that, index }) => {
    const birthDate = that.form(index, 'birthDate', false).value;
    const age = that.form(index, 'age', false).value;
    return (
        <>
            <Label className="transfer-label" md={12} ><label className="label-name">Birthdate: </label>{birthDate ? ` ${momentToString(birthDate)} (${age} years)` : 'Unknown'}</Label>
        </>
    )
}

const Sex = ({ that, index }) => {
    const sex = that.form(index, 'sex').value;
    return (
        <Label className="transfer-label" md={12}><label className="label-name">Sex:</label> {sex ? sex : 'Unknown'}</Label>
    )
}


const Weight = ({ that, index }) => {
    const weight = that.form(index, 'weight', false).value;
    const wieghtUnit = that.form(index, 'weightUnit', false).value;
    return (
        <Label className="transfer-label" md={12} ><label className="label-name">Weight:</label> {weight ? weight : 'Unknown'} {wieghtUnit ? wieghtUnit : ''}</Label>
    )
}


const Height = ({ that, index }) => {
    const height = that.form(index, 'height', false).value;
    const heightUnit = that.form(index, 'heightUnit', false).value;
    return (
        <Label className="transfer-label" md={12} ><label className="label-name">Height:</label>{height ? height : 'Unknown'} {heightUnit ? heightUnit : ''}</Label>
    )

}
const EyeColor = ({ that, index }) => {
    const eyeColor = that.form(index, 'eyeColor').value;
    return (
        <Label className="transfer-label" md={12}><label className="label-name">Eye Color: </label>{eyeColor ? eyeColor : 'Unknown'}</Label>
    )
}

const HairColor = ({ that, index }) => {
    const hairColor = that.form(index, 'hairColor').value;
    return (
        <Label className="transfer-label" md={12}><label className="label-name">Hair Color: </label>{hairColor ? hairColor : 'Unknown'}</Label>
    )
}

